module.exports = __webpack_public_path__ + "img/search_outline.09dd1dd3.svg";